import type {DataFormPartConfiguration} from 'schema/types';
import type {Part} from 'schemaDefinition/types';
import {useDataFormConfigurationContext} from '../contexts';

type Props = Partial<Pick<Part, 'type' | 'key' | 'name'>>;

export const usePartConfiguration = (
  part: Props | undefined,
): DataFormPartConfiguration | undefined => {
  const {parts} = useDataFormConfigurationContext();

  if (!part || part.type === 'expand') {
    return undefined;
  }

  const partKey = part.key ?? part.name;

  return partKey ? parts?.[partKey] : undefined;
};
